import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractSigningCertificateOfCompletion.Save.IRequest;
type Response = Api.Core.ContractSigningCertificateOfCompletion.Save.IResponse;
type Headers = Api.Core.ContractSigningCertificateOfCompletion.Save.IHeaders;
const url = '/api/Sales/Contract/:id/SigningCertificateOfCompletion';
export default async function contractSigningCertificateOfCompletionSaveApi(
  body?: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.contractId }),
    body,
    headers: getDefaultHeaders(),
  });
}
